///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.thoughtspot = abcsetup.thoughtspot || {};
abcsetup.thoughtspot.invitations = abcsetup.thoughtspot.invitations || {};
abcsetup.thoughtspot.invitations.index = abcsetup.thoughtspot.invitations.index || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.thoughtspot.invitations.index = {
    init: function () {
        abcsetup.setTitle('ThoughtSpot Registrations');

        // Outstanding items delete button clicked
        $(document).on('click', '.delete-registration', function () {
            var _this = $(this);

            abcsetup.alerts.confirm('Delete ThoughtSpot Invite', 'Are you sure you want to delete this invite?', function (resp) {
                if (resp) {
                    abcsetup.thoughtspot.invitations.index.delete(_this.data('id'));
                }
            });

            return false;
        });

        $('#send_to_all').on('click', function(e) {
            var _this = $(this);

            abcsetup.alerts.confirm('Send Invites to All.', 'Are you sure you want to send ivitation emails to ALL the registered suppliers?', function (resp) {
                if (resp) {
                    window.location.href = '/thoughtspot/invitations/'+ _this.data('event-id') +'/send_alert_to_all'
                }
            });
        });
    },

    /**
     *
     */
    delete: function (id) {
        abcsetup.blockUI(true);
        axios.delete('/thoughtspot/invitations/' + id).then(response => {
            window.LaravelDataTables["thoughtspot-registrations-table"].ajax.reload();
            abcsetup.unblockUI();
        });
    },

    /**
     * _jquery.uploader
     *      An upload is complete this is the callback
     */
    uploadDone: function () {
        let success = abcsetup.uploader.uploadResult.success;
        let errors = abcsetup.uploader.uploadResult.errors;

        if (success) {
            abcsetup.alerts.show('Exhibitor Import', "All invitations passed validation and have been imported successfully.");
            window.LaravelDataTables["thoughtspot-registrations-table"].ajax.reload();
        } 
        
        if (errors) {
            abcsetup.alerts.show('Exhibitor import errors', "Your suppliers could not be imported because of the following errors: \n" + errors);
        }
    },
}
